import React, { Fragment } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Typography } from "@mui/material";
import ReactApexChart from "react-apexcharts";

const ScoreHistory = ({
    state,
    fromMentor
}) => {
    return (
        <CommonCard
            paddingBottom="0px"
            padding="0px"
            borderRadius={2}
            headerContent={
                <Fragment>
                    <Box p={2} display="flex" justifyContent="space-between">
                        {!fromMentor && (
                            <Box>
                                <Typography fontWeight={600}>Score History</Typography>
                                <Typography fontSize={14} color="background.dark">Track how your scores have changed over time.</Typography>
                            </Box>)}
                        <Box>
                            <Typography fontWeight={600}>Score History</Typography>
                            <Typography fontSize={14} color="background.dark">Last 6 Months</Typography>
                        </Box>
                    </Box>
                </Fragment>
            }
            content={
                <ReactApexChart options={state.options} series={state.series} type="line" height={350} />
            }
        />
    )
}

export default ScoreHistory;